import { createReducer } from '@reduxjs/toolkit';
import { buildActionStatus } from '../utils';
import * as ma from './messageActions';
const initialState = {
  messages: [],
  socket: null,
  raisedHand: false,
  transcript: [],
  unreadMessages: 0,
  actionStatus: buildActionStatus(ma),
};

const messageReducer = createReducer(initialState, {
  [ma.putMessageAction]: (state, { payload }) => ({
    ...state,
    messages: [...state.messages, { ...payload.payload }],
  }),
  [ma.resetStateAction]: () => ({
    ...initialState,
  }),
  [ma.setSocketAction]: (state, { payload: { socket } }) => ({
    ...state,
    socket,
  }),
  [ma.setRaisedHandAction]: (state, { payload: { raisedHand } }) => ({
    ...state,
    raisedHand,
  }),
  [ma.setUnreadMessagesAction]: (state, { payload }) => ({
    ...state,
    unreadMessages: payload,
  }),
  [ma.setAllMessagesAction]: (state, { payload }) => ({
    ...state,
    messages: payload.messages.filter((m) => m.type === 'chat-message').map((m) => m.payload),
  }),
});

export default messageReducer;
